module.exports = __webpack_public_path__ + "static/media/pencil.092b38bf.svg";